import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";

@Component({
  selector: "app-button-page-video-component",
  templateUrl: "./button-page-video-component.component.html",
  styleUrls: ["./button-page-video-component.component.scss"],
})
export class ButtonPageVideoComponentComponent implements OnInit, OnDestroy {


  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,


  ) {}



  @Input() button_id: string;
  button: MenuButton;
  mode: string;

  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_bgcolor: string;
  row_id: string;
  button_option_color = '#ffffff'
  button_option = [];
  button_value = [];
  button_page_data;
  button_label ='' ;
  button_sublabel = '';
  data: any;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key : string = "button"

  ngOnInit() {


    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button&&
          data.button.button_id == this.button_id
        ) {

          this.data = data.data;
          this.sortedButtonList = data.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];

          this.button = { ...data.button };
          this.mode = localStorage.getItem("mode");
          if (this.button.button_label) {
            this.button_label = this.button.button_label;
          }
          if (this.button.button_sublabel) {
            this.button_sublabel = this.button.button_sublabel;
          }
          if (this.button.button_page_data) {
            this.button_page_data = this.button.button_page_data;
          }
          if (this.button.button_value) {
            this.button_value = this.button.button_value;
          }
        }
      }
    );
    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && data["buttonList"][this.button_id] && !data.fromButton) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
        }
      }
    );
  }

  changeVideoUrl(url){
    this.button.button_page_data.video_url = url;
    this.mdw.changeTab({ button: this.button, tab:{module: "page" }}, this.mode, true);

 /// update the button in the data
 this.buttonList[this.button_id] = this.button;
 let index = this.sortedButtonList[this.button.row_id].findIndex(
   (e) => e.button_id == this.button_id
 );
 this.sortedButtonList[this.button.row_id][index] = { ...this.button };
 this.data["sortedButtonList"] = this.sortedButtonList;
 this.data["buttonList"] = this.buttonList;
 this.data["off_canvas_key"] = this.off_canvas_key;
 this.data["currentButton"] = this.button;

 this.mdw._currentMenuContainer.next(this.data);

 ////////////////////////////***********************/????????????//////////
  }

  changeLabel(label){
    this.button.button_label = label;
    this.mdw.changeTab({ button: this.button, tab:{module: "page" }}, this.mode, true);

 /// update the button in the data
 this.buttonList[this.button_id] = this.button;
 let index = this.sortedButtonList[this.button.row_id].findIndex(
   (e) => e.button_id == this.button_id
 );
 this.sortedButtonList[this.button.row_id][index] = { ...this.button };
 this.data["sortedButtonList"] = this.sortedButtonList;
 this.data["buttonList"] = this.buttonList;
 this.data["off_canvas_key"] = this.off_canvas_key;
 this.data["currentButton"] = this.button;

 this.mdw._currentMenuContainer.next(this.data);

 ////////////////////////////***********************/????????????//////////
  }

  changeSubLabel(sublabel){
    this.button.button_sublabel = sublabel;
    this.mdw.changeTab({ button: this.button, tab:{module: "page" }}, this.mode, true);

 /// update the button in the data
 this.buttonList[this.button_id] = this.button;
 let index = this.sortedButtonList[this.button.row_id].findIndex(
   (e) => e.button_id == this.button_id
 );
 this.sortedButtonList[this.button.row_id][index] = { ...this.button };
 this.data["sortedButtonList"] = this.sortedButtonList;
 this.data["buttonList"] = this.buttonList;
 this.data["off_canvas_key"] = this.off_canvas_key;
 this.data["currentButton"] = this.button;

 this.mdw._currentMenuContainer.next(this.data);

 ////////////////////////////***********************/????????????//////////
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
